import React, {useRef} from 'react';
import {createListCollection, Portal, Select, Box} from "@chakra-ui/react";

export const NestedSelect = ({defaultValue, plainTree, onValueChange, placeholder, ...props}) => {

    const selectRef = useRef(null);

    const collection = createListCollection({
        items: plainTree
    });

    return <Select.Root
        ref={selectRef}
        positioning={{sameWidth: false}}
        collection={collection}
        size="sm"
        defaultValue={defaultValue}
        onValueChange={(e) => onValueChange(e)}
        {...props}
    >
        <Select.HiddenSelect />
        <Select.Control w={'70rem'}>
            <Select.Trigger>
                <Select.ValueText placeholder={placeholder} />
            </Select.Trigger>
            <Select.IndicatorGroup>
                <Select.Indicator />
            </Select.IndicatorGroup>
        </Select.Control>
        <Portal>
            <Select.Positioner>
                <Select.Content w={'70rem'}>
                    {collection.items.map((item) => (
                        <Select.Item
                            item={item}
                            key={item.value}
                            pl={`${item.depth}rem`}
                            position="relative"
                        >
                            {
                                Array.from({length: Math.max(0, item.depth)}).map((_, i) => {
                                    return <Box
                                        key={`select-item-${item.value}-${i}`}
                                        position="absolute"
                                        h="100%"
                                        w="1px"
                                        bg={"white"}
                                    />
                                })
                            }
                            {item.label}
                            <Select.ItemIndicator />
                        </Select.Item>
                    ))}
                </Select.Content>
            </Select.Positioner>
        </Portal>
    </Select.Root>;
};

export default NestedSelect;
